import React from "react";
import {
  Avatar,
  Box,
  Divider,
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Tooltip,
} from "@mui/material";
import LightModeOutlinedIcon from "@mui/icons-material/LightModeOutlined";
import BedtimeOutlinedIcon from "@mui/icons-material/BedtimeOutlined";
import { useThemeMode } from "../../contexts/ThemeModeContext";
import { useState } from "react";
import { useAuth } from "../../contexts/AuthContext";
import LogoutOutlinedIcon from '@mui/icons-material/LogoutOutlined';
import { useNavigate } from "react-router-dom";
import { auth } from "../../firebase";

function RightSidebar() {
  const { currentUser } = useAuth();
  const { modeSetting, setThemeModeSetting, activePaletteMode } =
    useThemeMode();
  
  const navigate = useNavigate();

  const [anchorElTheme, setAnchorElTheme] = useState(null);
  const openThemeMenu = Boolean(anchorElTheme);

  const [anchorEl, setAnchorEl] = useState(null);

  const handleAvatarClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };


  const handleThemeMenuClick = (event) => setAnchorElTheme(event.currentTarget);
  const handleThemeMenuClose = () => setAnchorElTheme(null);

  const handleThemeChange = (selectedUserChoice) => {
    setThemeModeSetting(selectedUserChoice);
    handleThemeMenuClose();
  };

  const handleLogout = async () => {
    try { await auth.signOut(); navigate('/login'); }
    catch (error) { console.error("Failed to log out", error); }
  };

  const getThemeIcon = () => {
    if (activePaletteMode === "dark") return <LightModeOutlinedIcon />;
    return <BedtimeOutlinedIcon />;
  };

  return (
    <Box component="nav" sx={{ width: "60px", }}>
      <Drawer
        anchor="right"
        variant="permanent"
        sx={(theme)=>({
          "& .MuiDrawer-paper": {
            boxSizing: "border-box",
            width: "48px",
            backgroundImage: "none",
            borderRadius: "0px",
            height: "100%",
            backgroundColor: theme.palette.mode === 'dark' ? '#201a44':'rgb(255,255,255)'
          },
        })}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            alignItems: "center",
            height: "100%",
            padding:'12px 0'
          }}
        >
          <Box>
            <Avatar onClick={handleAvatarClick} sx={(theme) => ({
              bgcolor: theme.palette.mode === 'dark' ? 'rgba(124,172,248,0.08)' : 'rgba(11,87,208,0.08)',
              color: theme.palette.mode === 'dark' ? '#fafafa' : '#121212',
              cursor:'pointer',
              width: '32px',
              height: '32px',
              boxShadow: 'rgba(255, 255, 255, 0.2) 0px 0px 10px 0px inset',
            })}>
              {currentUser ? currentUser.email[0].toUpperCase() : 'U'}
            </Avatar>

            {/* Menu for Profile Options */}
            <Menu
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={handleMenuClose}
              anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
              transformOrigin={{ vertical: "top", horizontal: "right" }}
            >
              <List>
                {currentUser && (
                  <>
                    <ListItem sx={{justifyContent: 'center'}}>
                      <Avatar sx={(theme) => ({
                        bgcolor: theme.palette.mode === 'dark' ? 'rgba(124,172,248,0.08)' : 'rgba(11,87,208,0.08)',
                        color: theme.palette.mode === 'dark' ? '#fafafa' : '#121212',
                      })}>
                        {currentUser ? currentUser.email[0].toUpperCase() : 'U'}
                      </Avatar>
                    </ListItem>

                    <ListItem>
                      <ListItemText primary={currentUser.email} />
                    </ListItem>

                    <Divider/>

                    <ListItem disablePadding onClick={handleLogout}>
                        <ListItemButton sx={{ justifyContent: 'center' }}>
                          <ListItemIcon sx={{ minWidth: '40px', justifyContent: 'center' }}>
                            <LogoutOutlinedIcon sx={{my:'2px'}} color="error" /> 
                            <ListItemText primary="Logout" primaryTypographyProps={{ color: 'error.main', fontWeight: 'medium' }} />
                          </ListItemIcon>
                          
                        </ListItemButton>
                    </ListItem>
                  </>
                )}
              </List>

            </Menu>
          </Box>

          <Box>
            <List>
              <ListItem disablePadding>
                <Tooltip
                  title={`Change theme (Current choice: ${
                    modeSetting || "System"
                  })`}
                  placement="right"
                >
                  <ListItemButton
                    sx={{ padding: "0px" }}
                    onClick={handleThemeMenuClick}
                  >
                    <ListItemIcon
                      sx={{ minWidth: "40px", justifyContent: "center" }}
                    >
                      {getThemeIcon()}
                    </ListItemIcon>
                  </ListItemButton>
                </Tooltip>
              </ListItem>
              <Menu
                anchorEl={anchorElTheme}
                open={openThemeMenu}
                onClose={handleThemeMenuClose}
                anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                transformOrigin={{ vertical: "top", horizontal: "right" }}
              >
                <MenuItem
                  onClick={() => handleThemeChange("light")}
                  selected={modeSetting === "light"}
                >
                  <LightModeOutlinedIcon sx={{ mr: 1.5 }} fontSize="small" />{" "}
                  Light
                </MenuItem>
                <MenuItem
                  onClick={() => handleThemeChange("dark")}
                  selected={modeSetting === "dark"}
                >
                  <BedtimeOutlinedIcon sx={{ mr: 1.5 }} fontSize="small" /> Dark
                </MenuItem>
                <MenuItem
                  onClick={() => handleThemeChange("system")}
                  selected={modeSetting === "system" || !modeSetting}
                >
                  {activePaletteMode === "dark" ? (
                    <LightModeOutlinedIcon sx={{ mr: 1.5 }} fontSize="small" />
                  ) : (
                    <BedtimeOutlinedIcon sx={{ mr: 1.5 }} fontSize="small" />
                  )}{" "}
                  System
                </MenuItem>
              </Menu>
            </List>
          </Box>
        </Box>
      </Drawer>
    </Box>
  );
}

export default RightSidebar;
